import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'shareholders';

export default {
    find: (params) => {
        return axios.get(`${base.baseUrl}/${namespace}/find/${params.id}`)
    },
    save: (files, params) => {
        const formData = new FormData();
        if(files.length > 0) {
            for(const file of files) {
                formData.append("files", file);
            }
        }

        if(params.id) {
            formData.append('id', params.id);
        }

        if(params.moralPersonFather) {
            formData.append('moralPersonFather', params.moralPersonFather);
        }

        formData.append('personType', params.personType);

        formData.append('address', JSON.stringify(params.address || null));

        if(params.personType === 'MORAL') {
            formData.append('legalName', params.legalName);
            formData.append('RFC', params.RFC);
            formData.append('giro', JSON.stringify(params.giro));
            formData.append('nationality', JSON.stringify(params.nationality));
            formData.append('constitutionDay', params.constitutionDay);
        } else {
            formData.append('islegalRepresentative', params.islegalRepresentative);
            formData.append('name', params.name);
            formData.append('lastName', params.lastName);
            formData.append('secondLastName', params.secondLastName);
            formData.append('birthDay', params.birthDay);
            formData.append('gender', params.gender);
            formData.append('occupation', params.occupation);
            formData.append('extraInfo', JSON.stringify(params.extraInfo || null));
        }
        formData.append('percentShare', params.percentShare);
        formData.append('organizationInfo', params.organizationInfo);
        formData.append('fileDocuments', JSON.stringify(params.fileDocuments || null));

        return axios.post(`${base.baseUrl}/${namespace}/save`, formData)
    },
    loadTree: (params) => {
        return axios.post(`${base.baseUrl}/${namespace}/get-organization-tree`, params)
    },
    delete: (params) => {
        return axios.post(`${base.baseUrl}/${namespace}/delete`, params)
    },
    setDigitalSign: (params) => {
        return axios.post(`${base.baseUrl}/${namespace}/set-digital-sign`, params)
    },
    saveLegal: (files, params) => {
        const formData = new FormData();
        if(files.length > 0) {
            for(const file of files) {
                formData.append("files", file);
            }
        }

        if(params._id) {
            formData.append('_id', params._id);
        }
        if(params.account) {
            formData.append('account', params.account);
        }
        formData.append('organizationInfo', params.organizationInfo);
        formData.append('fileDocuments', JSON.stringify(params.fileDocuments));
        if(params.preDocumentAccepted) {
            formData.append('preDocumentAccepted', JSON.stringify(params.preDocumentAccepted));
        }
        if(params.documents) {
            formData.append('documents', JSON.stringify(params.documents));
        }
        return axios.post(`${base.baseUrl}/${namespace}/save-legal-data`, formData)
    }
}
